import { useActions, type UseActionsOptions } from '../../hooks/useActions';
import type { TableName, ActionContext } from '../../config/actions';
import { ActionButton } from './ActionButton';
import { ActionMenu } from './ActionMenu';

interface ActionBarProps {
  table: TableName;
  row: Record<string, unknown>;
  context?: ActionContext;
  className?: string;
  /** Callbacks for record-level actions (edit, delete) */
  actionOptions?: UseActionsOptions;
}

export function ActionBar({
  table,
  row,
  context = 'detail',
  className = '',
  actionOptions,
}: ActionBarProps) {
  const { getProminent, getInline, getMenu, execute, isExecuting } = useActions(table, row, actionOptions);

  const prominentActions = getProminent();
  const inlineActions = getInline();
  const menuActions = getMenu();

  const displayProminent = context === 'list' ? prominentActions.slice(0, 1) : prominentActions;
  const displayInline = context === 'list' ? [] : inlineActions;
  const displayMenu = context === 'list' ? [] : menuActions;

  if (displayProminent.length === 0 && displayInline.length === 0 && displayMenu.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {displayProminent.map((action) => (
        <ActionButton
          key={action.id}
          action={action}
          onExecute={() => execute(action)}
          isExecuting={isExecuting}
          variant="primary"
          size="sm"
        />
      ))}

      {displayInline.map((action) => (
        <ActionButton
          key={action.id}
          action={action}
          onExecute={() => execute(action)}
          isExecuting={isExecuting}
          variant="secondary"
          size="sm"
        />
      ))}

      {displayMenu.length > 0 && (
        <ActionMenu
          actions={displayMenu}
          onExecute={execute}
          isExecuting={isExecuting}
        />
      )}
    </div>
  );
}
